import { Skeleton } from "@/components/ui/skeleton"

// Rendered while a ```chart fence is still streaming in. The raw content string
// tests fence-unclosed; skeleton stays visible until the closing fence arrives
// and ChartBlock swaps in the real chart. Subtle coral tint signals this is a
// chart-in-progress rather than a generic content placeholder.
export function ChartSkeleton() {
  return (
    <div
      className="my-2 rounded-md border border-brand-coral/20 bg-brand-coral-wash/40 p-3"
      role="status"
      aria-label="Chart loading"
    >
      <Skeleton className="h-4 w-1/3 bg-brand-coral/20" />
      <div className="mt-3 flex gap-2">
        <Skeleton className="h-24 w-full bg-brand-coral/10" />
      </div>
      <div className="mt-2 flex justify-between">
        <Skeleton className="h-3 w-12 bg-brand-coral/10" />
        <Skeleton className="h-3 w-12 bg-brand-coral/10" />
        <Skeleton className="h-3 w-12 bg-brand-coral/10" />
      </div>
    </div>
  )
}
